import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Conectividadvpn`, method: 'GET', body: null, token: token})
}